import { gsap } from "gsap";

export default class AccordionHandler {
	init(options = {}) {
		const { oneAtATime = false } = options;
		const accordions = gsap.utils.toArray('[data-accordion="container"]');
		
		// Check if we should open the first accordion based on parent/wrapper element
		let shouldOpenFirst = false;
		if (accordions.length > 0) {
			// Look for a parent element with data-accordion-first-open="true"
			const firstAccordion = accordions[0];
			const parent = firstAccordion.closest('[data-accordion-first-open="true"]');
			shouldOpenFirst = parent !== null;
		}
		
		accordions.forEach((accordion, index) => {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			const content = accordion.querySelector('[data-accordion="content"]');
			
			// Only open the first accordion if the parent has data-accordion-first-open="true"
			if (index === 0 && shouldOpenFirst) {
				accordion.classList.add('is-active');
				accordion.style.height = `${trigger.offsetHeight + content.scrollHeight}px`;
			} else {
				accordion.classList.remove('is-active');
				accordion.style.height = `${trigger.offsetHeight}px`;
			}
			
			trigger.addEventListener('click', () => {
				const isActive = accordion.classList.contains('is-active');
				
				if (oneAtATime && !isActive) {
					// Close all other accordions
					accordions.forEach((otherAccordion) => {
						if (otherAccordion !== accordion && otherAccordion.classList.contains('is-active')) {
							const otherTrigger = otherAccordion.querySelector('[data-accordion="trigger"]');
							otherAccordion.classList.remove('is-active');
							gsap.to(otherAccordion, { height: otherTrigger.offsetHeight, duration: 0.5, ease: 'power4.out' });
						}
					});
				}
				
				accordion.classList.toggle('is-active');
				const targetHeight = isActive 
					? trigger.offsetHeight
					: trigger.offsetHeight + content.scrollHeight;
				gsap.to(accordion, { height: targetHeight, duration: 0.5, ease: 'power4.out' });
			});
		});
		function updateAccordionHeight(accordion) {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			const content = accordion.querySelector('[data-accordion="content"]');
			const isActive = accordion.classList.contains('is-active');
			const targetHeight = isActive 
				? trigger.offsetHeight + content.scrollHeight
				: trigger.offsetHeight;
			gsap.set(accordion, { height: targetHeight });
		}
		window.addEventListener('resize', () => accordions.forEach(updateAccordionHeight));
	}
}